export default __webpack_public_path__ + "static/BlogList-c0b3c0afe59fd4a4519d58bae45766af.jpg";